export enum ErrorCodes {
    FailedToGetIp = 'YGC-0001',
    FailedToGetMetadata = 'YGC-0002',
    FailedToGetConvoMetadata = 'YGC-0003',
    FailedToVerifyRecontact = 'YGC-0004',
    FailedToGetPageContent = 'YGC-0005',
    FailedToLoadHeroSection = 'YGC-0006',
    FailedToGetCountryFromHeader = 'YGC-0007',
}
